export const myInfo = {
    firstName: 'Sanket',
    lastName: 'Waghmare',
    profile_picture:'https://res.cloudinary.com/s-kart/image/upload/v1733474047/vefe6djrvhpi04pra2fm.jpg',
    about: "Hello! I'm Sanket, a passionate Computer Engineer from Mumbai and a 2024 graduate. I specialize in web development and enjoy creating software solutions that bring ideas to life. With a strong technical foundation in modern web technologies, I'm focused on writing clean, efficient code and continuously improving my skills.As an entry-level web developer, I excel at solving problems and turning complex challenges into simple, functional solutions. Along with my technical expertise, I bring excellent communication and leadership skills, ensuring that I'm not only able to code but also deliver high-quality results.I'm always excited to work on new projects and build software that makes a difference",
    skills: [
        {
            skillName: 'React.Js',
            expertise: '95%'
        },
        {
            skillName: 'HTML',
            expertise: '100%'
        },
        {
            skillName: 'JavaScript',
            expertise: '75%'
        },
        {
            skillName: 'CSS',
            expertise: '98%'
        },
        {
            skillName: 'TailwindCSS',
            expertise: '95%'
        },
        {
            skillName: 'Java',
            expertise: '70%'
        },
        {
            skillName: 'Node.js',
            expertise: '70%'
        },
        {
            skillName: 'Redux',
            expertise: '90%'
        },
        {
            skillName: 'Express.js',
            expertise: '60%'
        },{
            skillName:'MongoDB',
            expertise:'60%'
        },
    ],
    tools:[
        {
            url:'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png'

        },{

        }
    ],
    projects: [
       {   
            image:"https://res.cloudinary.com/charchagram/image/upload/v1695300919/wdwdwdwdwdwdwdwdwdwdw1_hoyllz.webp",
            name: "चर्चाGRAM - A SOCIAL MEDIA PLATFORM",
            description: "Implemented key features such as real-time messaging, video calling, post creation, trending topics section, and notifications."
            ,liveLink:"https://charchagram.onrender.com",
            github:'https://github.com/SanketRW4503/charchagram-frontend'
        },
        {   image:"https://res.cloudinary.com/s-kart/image/upload/v1727529397/pz6s3h0lqnkept9ysvur.png",
            name: "S-KART E-COMMERCE PLATFORM",
            description: "Implemented essential features including product listing, search functionality, shopping cart management, and secure order processing with payment gateway integration."
            ,liveLink:"https://s-kart.onrender.com",
            github:'https://github.com/SanketRW4503/s-kart'
        },
        {   image:"https://res.cloudinary.com/s-kart/image/upload/v1727529590/azqe4dlo9qqsyknvtc4h.png",
        name: "Disney+Hotstar Powered by Gemini",
        description: "A frontend web application that replicates the Disney+Hotstar streaming platform. It features an AI search tool powered by Gemini, making it easy for users to find movies, all within a familiar and user-friendly design."
        ,liveLink:"https://hotstargpt-9b070.web.app",
        github:"https://github.com/SanketRW4503/disney-hotstar_clone"
        },
        {   image:"https://res.cloudinary.com/demo/image/upload/l_text:Arial_100:Weather/photo-1430609098125-581618d0482f_xvayby",
        name: "Weather App",
        description: "This is an simple reactjs weather web application which shows the current weather details by using WeatherApi "
        ,liveLink:"https://sanketrw4503.github.io/react-weatherapp",
        github:"https://github.com/SanketRW4503/react-weatherapp"
    },

    ],
    profession:["Frontend Engineer","Web Developer","Software Engineer","React.js Developer"],
    linkedin:"https://www.linkedin.com/in/sanket-waghmare",
    github:"https://github.com/SanketRW4503",
    leetcode:"https://leetcode.com/u/sanket4503/",
    geeksforgeeks:"https://www.geeksforgeeks.org/user/sanketwaghmare4503/",
    instagram:"https://www.instagram.com/sanket__rw/",
    twitter:"https://twitter.com/SanketW23353060",
    resume:"https://drive.google.com/file/d/1hZD1BLxiGqrEalo9G_Pb7nSaW7OlsFCY/view"
}

export const uiInfo={
    homeBG:"https://res.cloudinary.com/s-kart/image/upload/v1727531169/l6scxzj2umrpvsu4ofdb.png"
}
